import * as React from "react";

import "./resize-overlay.scss";

import {cs}       from "@Common/react/chain-services";
import {Static2}  from "@Common/react/static-2";
import {keepOnly} from "@Common/utils/objects";

import {addSize1}   from "../../../common/add-size-1";
import {addVector1} from "../../../common/add-vector";
import {Dragging}   from "../../../common/dragging";
import {toCssPos}   from "../../../common/to-css-pos";

export const ResizeOverlay = ({rect, onMove}) => cs(
    ({}) => (
        <div
            className="resize-overlay resize-overlay-5c3"
            style={{
                ...toCssPos(addVector1(rect, -10)),
                ...addSize1(rect, 10 * 2),
            }}
        >
            {ResizeSvg({
                size: keepOnly(rect, ["width", "height"]),
                onMove,
            })}
        </div>
    ),
);

const ResizeSvg = ({size, onMove}) => cs(
    ["dragging", (_, next) => Dragging({next})],
    ["mover", (_, next) => Static2({next})],
    ({dragging, mover}) => (
        <svg viewBox={[-10, -10, size.width + 10*2, size.height + 10*2].join(" ")}>
            <rect {...{
                x: 0,
                y: 0,
                ...size,
                ...dragging.handle,
            }}/>

            {dragging.renderActive({
                onStart: () => {
                    mover.set(onMove());
                },
                onChange: (delta) => {
                    mover.get()(delta);
                },
            })}
        </svg>
    ),
);
